import packageJson from '../package.json';

export const currency = '₹'
export const appVersion = packageJson.version 